module.exports = __webpack_public_path__ + "static/img/gpt71.5ee77a1b.png";